  export const API_URL = "https://updesdemo-api.srmtechsol.com/";
// export const API_URL = "http://localhost:8013/";
//export const API_URL = "http://192.0.0.204:8014/";
// export const API_URL = "http://localhost:8014/";


/** Used for `Authorization: ApiKey …` on `/api/security/nonce` (see Login.jsx). */

export const API_KEY = '';
export const PASSWORD_ENCRYPTION_KEY = API_KEY || 'change-me-password-key';

export { AUTH_USE_HTTPONLY_COOKIE } from '../config/authFlags';
export {
    getToken,
    getAuthHeaders,
    getUserClaimsForUi,
    getClaimsForRoleUi,
    hasAuthSession,
    setUserClaimsSnapshot,
} from '../utils/authStorage';
